export default __webpack_public_path__ + "static/media/Outcome-of-Board-Meeting-August-03-2026.3f05da6b.pdf";